//
// FilterItemBase.js
// BIRD
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../../lib";
import "../DataItem";
import "../../common/BIRDProperty";
import "../../common/BIRDExpression";

var FilterItemBase = createModule("BIRD::FilterItemBase", ["commons::PropertyOwner","commons::BaseModel","BIRD::BIRDModel","BIRD::DataItemOrPromptDefinition","BIRD::DataItemBase","BIRD::DataItem"], EventDispatcher, [
    ,
    {
        expression: 1,
        editorProperties: [1],
        systemGenerated: 2,
    },
    ,
    ,
    ,
    {
        _create: [4],
    },
    ,
]);
export default FilterItemBase;
